var map = {
	"../aplicaciones/aplicaciones.module": [
		"./src/app/modulos/aplicaciones/aplicaciones.module.ts",
		"default~aplicaciones-aplicaciones-module~perfiles-perfiles-module",
		"default~aplicaciones-aplicaciones-module~contenido-contenido-module",
		"common",
		"aplicaciones-aplicaciones-module"
	],
	"../autobuses/autobuses.module": [
		"./src/app/modulos/autobuses/autobuses.module.ts",
		"common",
		"autobuses-autobuses-module"
	],
	"../catalogos/catalogos.module": [
		"./src/app/modulos/catalogos/catalogos.module.ts",
		"catalogos-catalogos-module"
	],
	"../ciudades/ciudades.module": [
		"./src/app/modulos/ciudades/ciudades.module.ts",
		"default~ciudades-ciudades-module~facturas-facturas-module~oficinas-oficinas-module~sucursales-sucurs~f02c035a",
		"common",
		"ciudades-ciudades-module"
	],
	"../configuracion/configuracion.module": [
		"./src/app/modulos/configuracion/configuracion.module.ts",
		"configuracion-configuracion-module"
	],
	"../contenido/contenido.module": [
		"./src/app/modulos/contenido/contenido.module.ts",
		"default~aplicaciones-aplicaciones-module~contenido-contenido-module",
		"common",
		"contenido-contenido-module"
	],
	"../estados/estados.module": [
		"./src/app/modulos/estados/estados.module.ts",
		"common",
		"estados-estados-module"
	],
	"../facturas/facturas.module": [
		"./src/app/modulos/facturas/facturas.module.ts",
		"default~facturas-facturas-module~nominas-nominas-module~refacturas-refacturas-module~reportes-reportes-module",
		"default~ciudades-ciudades-module~facturas-facturas-module~oficinas-oficinas-module~sucursales-sucurs~f02c035a",
		"default~facturas-facturas-module~nominas-nominas-module",
		"common",
		"facturas-facturas-module"
	],
	"../inicio/inicio.module": [
		"./src/app/modulos/inicio/inicio.module.ts",
		"inicio-inicio-module"
	],
	"../nominas/nominas.module": [
		"./src/app/modulos/nominas/nominas.module.ts",
		"default~facturas-facturas-module~nominas-nominas-module~refacturas-refacturas-module~reportes-reportes-module",
		"default~facturas-facturas-module~nominas-nominas-module",
		"nominas-nominas-module"
	],
	"../oficinas/oficinas.module": [
		"./src/app/modulos/oficinas/oficinas.module.ts",
		"default~ciudades-ciudades-module~facturas-facturas-module~oficinas-oficinas-module~sucursales-sucurs~f02c035a",
		"common",
		"oficinas-oficinas-module"
	],
	"../operaciones/operaciones.module": [
		"./src/app/modulos/operaciones/operaciones.module.ts",
		"common",
		"operaciones-operaciones-module"
	],
	"../origenes-destinos/origenes-destinos.module": [
		"./src/app/modulos/origenes-destinos/origenes-destinos.module.ts",
		"common",
		"origenes-destinos-origenes-destinos-module"
	],
	"../perfiles/perfiles.module": [
		"./src/app/modulos/perfiles/perfiles.module.ts",
		"default~aplicaciones-aplicaciones-module~perfiles-perfiles-module",
		"perfiles-perfiles-module"
	],
	"../recuperacion/recuperacion.module": [
		"./src/app/modulos/recuperacion/recuperacion.module.ts",
		"recuperacion-recuperacion-module"
	],
	"../refacturas/refacturas.module": [
		"./src/app/modulos/refacturas/refacturas.module.ts",
		"default~facturas-facturas-module~nominas-nominas-module~refacturas-refacturas-module~reportes-reportes-module",
		"common",
		"refacturas-refacturas-module"
	],
	"../reportes/reportes.module": [
		"./src/app/modulos/reportes/reportes.module.ts",
		"default~facturas-facturas-module~nominas-nominas-module~refacturas-refacturas-module~reportes-reportes-module",
		"common",
		"reportes-reportes-module"
	],
	"../sucursales/sucursales.module": [
		"./src/app/modulos/sucursales/sucursales.module.ts",
		"default~ciudades-ciudades-module~facturas-facturas-module~oficinas-oficinas-module~sucursales-sucurs~f02c035a",
		"common",
		"sucursales-sucursales-module"
	],
	"../usuarios-modulo/usuarios-modulo.module": [
		"./src/app/modulos/usuarios-modulo/usuarios-modulo.module.ts",
		"common",
		"usuarios-modulo-usuarios-modulo-module"
	],
	"../usuarios/usuarios.module": [
		"./src/app/modulos/usuarios/usuarios.module.ts",
		"common",
		"usuarios-usuarios-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;